class EditOrderController {}
EditOrderController.$inject = [];
export default EditOrderController;

